module.exports = __webpack_public_path__ + "img/payouts.60737d41.webp";